import {
  ChartLineCustom,
  ApexChartBar,
} from '@/components/Home/utils/custom.home.types';
import { TABLE_WIDGET, STATUS_LABEL } from '@/components/Log/log.constants';
import i18n from '@/plugins/i18n';

export const getGraphConfig = ({
  widgetName,
  serviceKey,
  xLabel,
  yLabel,
  capability = 'LOG',
  savedSearchName,
  chartType = ChartLineCustom,
  queryMetric = 'meter_log_query_metric',
  entityType = 'Service',
  instanceIds,
  aggregationInfo,
  metricType,
}) => ({
  width: '48%',
  title: 'Service Load',
  header: {
    title: widgetName,
    titleIcon: '',
    content: [],
    enableCapabilityInfo: true,
    enableDeleteWidget: true,
    enableBarChartRedirect: chartType === ApexChartBar ? true : undefined,
    hideCustomToolbarButtons: chartType === ApexChartBar ? true : undefined,
  },
  serviceKey,
  serviceName: savedSearchName,
  capability: capability,
  chartColor: chartType === ChartLineCustom ? ['#2BEECA'] : ['#FDFCAC'],
  height: '12.5em',
  entityType,
  independentSelector: false,
  metricType: metricType || 'REGULAR_VALUE',
  metricName: [
    {
      metricName: queryMetric,
    },
  ],
  queryMetricType: 'readMetricsValues',
  chartType: chartType,
  unit: 'CPM - calls per minute',
  axisLabels: {
    x: xLabel,
    y: yLabel,
  },
  labels: {
    xAxis: 'Time',
    yAxis: 'CPM',
  },
  widgetName,
  instanceIds,
  aggregationInfo,
});

export const getMultiChartGraphConfig = ({
  width = '48%',
  title,
  header = {
    title: '',
    titleIcon: '',
    content: [],
  },
  serviceKey,
  capability,
  chartColor = [],
  height = '12.5em',
  valueColumn,
  formula = 'roundUpToThreeDecimal',
  graphTitles = {
    x: i18n.global.t('aws.time'),
    y: i18n.global.t('aws.count'),
  },
  entityType,
  instances,
  metricType = 'REGULAR_VALUE',
  metricName,
  queryMetricType,
  chartType,
  unit = i18n.global.t('aws.cpm'),
  axisLabels = {
    x: i18n.global.t('aws.time'),
    y: i18n.global.t('aws.count'),
  },
  labels,
  widgetName,
  actionPath,
  aggregationInfo,
}) => ({
  width,
  title,
  header,
  serviceKey,
  capability,
  chartColor,
  height,
  valueColumn,
  graphTitles,
  entityType,
  instanceIds: instances,
  metricType,
  formula,
  metricName: [
    {
      metricName,
    },
  ],
  queryMetricType,
  chartType,
  unit,
  axisLabels,
  labels,
  widgetName,
  actionPath,
  aggregationInfo,
});

export const getLabelConfig = ({
  entityType = 'Service',
  metricName = 'meter_log_query_metric',
  widgetName,
  serviceKey,
  savedSearchName,
  capability = 'LOG',
}) => ({
  header: { metricInfoLabel: savedSearchName },
  entityType,
  metricName: metricName ? [{ metricName }] : undefined,
  widgetName,
  serviceKey,
  capability,
  chartType: STATUS_LABEL,
  queryMetricType: 'readMetricsValues',
});

export const getTableConfig = ({
  metricName,
  widgetName,
  serviceKey,
  savedSearchName,
  capability = 'LOG',
}) => ({
  header: { metricInfoLabel: savedSearchName },
  metricName: metricName ? [{ metricName }] : undefined,
  widgetName,
  serviceKey,
  capability,
  chartType: TABLE_WIDGET,
});
